import { IActionCreatorAsync } from "core/actions/Actions.interfaces";
import { ILicense } from "reducers/Reducers.interfaces";
import { IlicenseCard } from "../Tenant.types";

export interface licenseFormProps {
  dataSource:Array<IlicenseCard>
  title: any
  onCancelClick: (id:string | null, data: any)=>void
  updateLicenseByApp: IActionCreatorAsync
  createLicenseAllocationUpdateEvent: IActionCreatorAsync
  context: string
  id: any
  license?: ILicense
  app_code: string
  partnerAccountId?: string
  type: string
  licenseFeatureVersion?: LicenseFeatureVersion
  showToggle?: boolean
}

export enum LicenseFormActions {
  NO_CHANGE = 'no-change',
  ADD = 'add',
  SUBTRACT = 'subtract',
  RESET = 'reset'
}

export enum LicenseFeatureVersion {
  V1 = 'v1',
  V2 = 'v2',
  V2_5 = 'v2.5'
}